import QFormItem from './src/QFormItem';

QFormItem.install = Vue => {
  Vue.component(QFormItem.name, QFormItem);
};

export default QFormItem;
